import { APICall } from "@/config/NetworkUtility";
import { logApiError } from "@/services/apiErrorLogger";
import { createAsyncThunk } from "@reduxjs/toolkit";

/* ==========================================
   GET NAVIGATIONS
========================================== */

export const getNavigations = createAsyncThunk(
  "navigation/getNavigations",
  async (payload, { rejectWithValue }) => {
    try {
      const queryParams = new URLSearchParams({
        ...payload,
      }).toString();

      const url = `v1/NavigationSetup/GetNavigationList?${queryParams}`;

      const result = await APICall("get", payload, url);

      if (result?.statuscode === 200 || result?.statuscode === 201) {
        return {
          data: result?.data || [],
          pagination: result?.pagination || {},
        };
      }

      return rejectWithValue(result);
    } catch (error) {
      logApiError(error, {
        source: "navigations",
        endpoint: "getNavigations",
        payload,
      });

      return rejectWithValue(error);
    }
  },
);

/* ==========================================
   CREATE NAVIGATION
========================================== */

export const createNavigation = createAsyncThunk(
  "navigation/createNavigation",
  async (payload, { rejectWithValue }) => {
    try {
      const result = await APICall(
        "post",
        payload,
        "v1/NavigationSetup/NavigationInsert",
      );

      if (result?.statuscode === 200 || result?.statuscode === 201) {
        return result;
      }

      return rejectWithValue(result);
    } catch (error) {
      logApiError(error, {
        source: "navigations",
        endpoint: "createNavigation",
        payload,
      });
    }
  },
);

/* ==========================================
   UPDATE NAVIGATION
========================================== */

export const updateNavigation = createAsyncThunk(
  "navigation/createNavigation",
  async (payload, { rejectWithValue }) => {
    try {
      const result = await APICall(
        "post",
        payload,
        "v1/NavigationSetup/NavigationUpdate",
      );

      if (result?.statuscode === 200 || result?.statuscode === 201) {
        return result;
      }

      return rejectWithValue(result);
    } catch (error) {
      logApiError(error, {
        source: "navigations",
        endpoint: "updateNavigation",
        payload,
      });
    }
  },
);

/* ==========================================
    NAVIGATION DROPDOWN LIST
========================================== */

export const getNavigationDropdownList = createAsyncThunk(
  "navigation/getNavigationDropdownList",
  async (payload, { rejectWithValue }) => {
    try {
      const queryParams = new URLSearchParams(payload).toString();

      const url = `v1/NavigationSetup/GetNavigationDropdownList?${queryParams}`;

      const result = await APICall("get", payload, url);

      if (result?.statuscode === 200 || result?.statuscode === 201) {
        return result?.data?.accountTypeList || [];
      }

      return rejectWithValue(result);
    } catch (error) {
      logApiError(error, {
        source: "navigation",
        endpoint: "getNavigationDropdownList",
        payload,
      });

      return rejectWithValue(error);
    }
  },
);
